import React, { useEffect } from "react"
import { App as AntApp } from "antd"
import { Routes, Route, useNavigate } from "react-router-dom"
import { Tabs, BackupTabs } from "../Tabs"
import { Login } from "../../pages/Login"
import { SystemLogin } from "../../pages/SystemLogin"
import * as routes from "../../routes"
import { EncryptedDataProvider } from "../../context/EncryptedData"
import { ThemeProvider } from "../../context/Theme"
import { ThemeWrapper } from "../Wrappers"
import { Layout } from "../Layout"
import { NotificationProvider } from "../../context/Notification"
import { ProtectedPage } from "../../pages/ProtectedPage"
import { NotFound } from "../../pages/NotFound"
import { STORAGE_SESSION_ACTIVE } from "../../constants"
import { getStorageVariable } from "../../utils/storage"

document.body.style.margin = "0"

const { HOME, LOGIN, BACKUP, SYSTEM_LOGIN } = routes

const RequireSystemAuth: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const navigate = useNavigate()
  const isSystemAuthenticated =
    getStorageVariable(STORAGE_SESSION_ACTIVE) === "true"

  useEffect(() => {
    if (!isSystemAuthenticated) {
      navigate(SYSTEM_LOGIN)
    }
  }, [navigate, isSystemAuthenticated])

  return isSystemAuthenticated ? <>{children}</> : null
}

const App: React.FC = () => {
  return (
    <ThemeProvider>
      <ThemeWrapper>
        <AntApp>
          <NotificationProvider>
            <EncryptedDataProvider>
              <Layout>
                <Routes>
                  <Route path={SYSTEM_LOGIN} element={<SystemLogin />} />
                  <Route
                    path={LOGIN}
                    element={
                      <RequireSystemAuth>
                        <Login />
                      </RequireSystemAuth>
                    }
                  />
                  <Route
                    path={HOME}
                    element={
                      <ProtectedPage>
                        <Tabs />
                      </ProtectedPage>
                    }
                  />
                  <Route
                    path={BACKUP}
                    element={
                      <ProtectedPage>
                        <BackupTabs />
                      </ProtectedPage>
                    }
                  />
                  <Route
                    path="*"
                    element={
                      <RequireSystemAuth>
                        <NotFound />
                      </RequireSystemAuth>
                    }
                  />
                </Routes>
              </Layout>
            </EncryptedDataProvider>
          </NotificationProvider>
        </AntApp>
      </ThemeWrapper>
    </ThemeProvider>
  )
}

export default App
